"use strict";

/**
 * @classdesc
 * Übersichtskarten-Modul
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.alias
 * @param {string} options.target
 * @param {gc.gis.map.GCMapView} [options.map=gc.gis.iface.map]
 * @param {string} [options.label='Übersichtskarte']
 * @param {boolean} [options.openOnStartup=false]
 * @param {boolean} [options.enableMenu=true]
 */
gc.gis.module.GCOverview = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	this.options        = options;
	this.label          = options.label || 'Übersichtskarte';
	this._reference_map = options.map || gc.gis.iface.map;
    this._menu_enabled = gc.gis.GCUtil.parseBool(options.enableMenu, true);
	this._overview_map  = undefined;

	this._overview_viewport = null;

	this._render();
	this._initMap();
	this._initEvents();
};
gc.gis.module.GCOverview.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 *
 */
gc.gis.module.GCOverview.prototype._initMap = function()
{
	var options_map = {
		target:     'gc_overview_map',
		zoom:       1,
		center:     this._reference_map.getCenter() || [0,0],
		rotation:   0,
		layers:     [],
		zoomRestricted: false,
		//projection: this._reference_map.getProjection()
		projection: gc.gis.iface.config.defaults.defaultCRS
	};

	this._overview_map = new gc.gis.map.GCMapView( options_map );
	this._overview_map.setProjection(this._reference_map.getProjection());

	this._impl = new gc.gis.module.GCOverview.OLMap({
		module: this,
		target: 'gc_overview_map'
	});
};

/**
 *
 */
gc.gis.module.GCOverview.prototype._initEvents = function () {
	var self = this;

	// Karten-Events
	this._overview_map.on( gc.gis.map.GCMapEvent.VIEWPORT_CHANGED, this, function(evt ) {
		self.updateViewport();
	});
	this._reference_map.on( gc.gis.map.GCMapEvent.PROJECTION_CHANGED, this, function(evt ) {
		self._impl._updateProjection();
	});
	this._reference_map.on( gc.gis.map.GCMapEvent.VIEWPORT_CHANGED, this, function(evt ) {
		self.updateViewport();
	});

	// Panel-Events
	this.element_panel._initEvents();	// Achtung: wird nicht im Konstruktor aufgerufen!

	// Layertree-Layermenü
	gc.gis.iface.onModuleAvailable(this, 'GCLayerTree', function(module) {
		module.registerHook(
			gc.gis.module.GCLayerTreeActionHook.LAYER_COMMON_ACTION,
			{
				initFunc: function(options)
				{
					var menu_item = self._renderLayerTreeMenuItem(options.layer);
					self._overview_map.on(gc.gis.map.GCMapEvent.LAYER_TREE_UPDATE_FINISHED, menu_item, function(evt) {
						menu_item.setActive( (self._getSimiliarLayers( options.layer ).length > 0) );
					});
					return menu_item;
				},
				destroyFunc: function(options)
				{
					self._overview_map.un( gc.gis.map.GCMapEvent.LAYER_TREE_UPDATE_FINISHED, options.widget );
				}
			}
		);
	});

	// Ansicht speichern
	gc.gis.iface.onModuleAvailable(this, 'GCViews', function(module) {
		module.registerHook(
			gc.gis.module.GCViewsHook.SAVE_CONFIG,
			{
				initFunc: function(options)
				{
					var viewport = self._overview_map.getViewport();
					options.viewConfig.overview = {
						viewport: {
							geometry:   viewport.geometry,
							projection: viewport.projection
						},
						layers: self._overview_map.getLayerConfigs()
					};
				},
				destroyFunc: function(options) {}
			}
		);
	});

	// Ansicht laden
	gc.gis.iface.on(gc.gis.GCApplicationEvent.VIEW_LOADED, this, function(evt) {
		self.applyView(evt.view);
	});
};

/**
 *
 */
gc.gis.module.GCOverview.prototype.getElement = function()
{
	return this.element_panel.getElement();
};

/**
 * Prüft ob die Übersichtskarte sichtbar ist.
 * @public
 * @method
 * @return {boolean}
 */
gc.gis.module.GCOverview.prototype.isVisible = function () {
	return this.element_panel.getElement().is(':visible');
};


/**
 * Schaltet die Sichtbarkeit der Übersichtskarte an oder aus.
 * @public
 * @method
 */
gc.gis.module.GCOverview.prototype.toggleVisibility = function () {
	var self = this;
	if (this.isVisible()) {
		this.element_panel.getElement().hide('fade', {
			complete: function (evt) {
				self.element_launcher.setActive(false);
			}
		});
	}
	else {
		this.element_panel.getElement().show('fade', {
			complete: function (evt) {
				// Vieport hier setzen, da erst bei Sichtbarkeit der Box OL die Map-Size korrekt ermitteln kann
				self.element_launcher.setActive(true);
				self._overview_map.getMap().updateSize();
				self.updateViewport();
				self._overview_map.setViewport(self._overview_viewport);
			}
		});
	}
};

/**
 *
 */
gc.gis.module.GCOverview.prototype._render = function()
{
	// Launcher
	this.element_launcher = new gc.gis.widget.GCToggleItem({
		containerClassName: 'gc-footer-component gc-hidden-sm gc-hidden-xs',
		icon: 'ms ms-map-o',
		tooltip: 'Übersichtskarte anzeigen/verstecken',
		active: false,
		action: new gc.gis.module.GCOverview.ToggleVisibility({
			module: this
		})
	});
	gc.gis.iface.ui.attach( this.element_launcher.getElement(), {
        target: gc.gis.iface.ui.footer.main,
        order: 0
	});

	// Panel
	this.element_panel = new gc.gis.module.GCOverview.Panel({
        module: this,
        active: this.active,
        headline: this.label,
        mapID: 'gc_overview_map',
        enableToolbar: this._menu_enabled
	});

	// initial verstecken
	if (!this.options.openOnStartup) {
		// this.toggleVisibility(); => nicht nutzen, sonst sieht man kurzeitig einen Rahmen
		this.element_panel.getElement().hide();
	}

	return this.element_panel;
};

/**
 *
 */
gc.gis.module.GCOverview.prototype._renderLayerTreeMenuItem = function( layer )
{
	var self = this;

	var menu_item = new gc.gis.widget.GCToggleItem({
		active: (self._getSimiliarLayers( layer ).length > 0),
		label: 'In Übersichtskarte anzeigen',
		click: function( evt ) {
			var similiar = self._getSimiliarLayers( layer );
			if( similiar.length > 0 )
			{
				for( var i=0; i<similiar.length; i++ )
				{
					similiar[i].getParent().removeLayer( similiar[i] );
				}
			}
			else
			{
				self._overview_map.loadLayer( layer.toObject() );
				self._overview_map.updateMap();
			}
			menu_item.setActive( !(similiar.length > 0) );
		}
	});

	return menu_item;
};

/**
 *
 */
gc.gis.module.GCOverview.prototype.getLayerTreeMenuItem = function( layer )
{
	var self = this;

};

/**
 *
 */
gc.gis.module.GCOverview.prototype._getSimiliarLayers = function( layer )
{
	return this._overview_map.getRoot().getLayersRecursive( function( o_layer ) {
		if( o_layer instanceof gc.gis.layer.GCGroupLayer
		 &&   layer instanceof gc.gis.layer.GCGroupLayer )
		{
			return o_layer.getOpacity() % 1 !== 0;	// nur semi-transparente Gruppen mitnehmen
		}
		// if( !o_layer.isReallyVisible() )
		// {
		// 	return false;
		// }
		return o_layer instanceof gc.gis.layer.GCLayer
		    &&   layer instanceof gc.gis.layer.GCLayer
		    && o_layer.getName()    === layer.getName()
		    && o_layer.getUrl()     === layer.getUrl()
			&& o_layer.isInternal() === layer.isInternal()
	});
};

/**
 * Wendet die Eigenschaften einer Ansicht auf die Übersichtskarte an.
 *
 * @param {Object} view
 */
gc.gis.module.GCOverview.prototype.applyView = function (view)
{
	// FIXME: Code duplication @ gc.gis.Application#setView
	var self = this;

	if(!view)
	{
		return;
	}

	gc.gis.iface.log.debug( self, 'GCOverview: Applying view "'+ view.name +'" ... ');

	self._overview_map.removeAllLayers();

	if(view.overview)
	{
		gc.gis.iface.log.debug( self, 'GCOverview: Found overview config in "'+ view.name +'".');

		// Layer laden
		if(view.overview.layers)
		{
			gc.gis.iface.log.debug( self, 'Loading '+ view.overview.layers.length + ' layers into GCOverview ... ');
			for(var i=0; i<view.overview.layers.length; i++)
			{
				self._overview_map.loadLayer(view.overview.layers[i]);
			}
		}

		// Viewport laden
		if(view.overview.viewport)
		{
			// Achtung: sofern die Übersichtskarte nicht sichtbar ist, darf der Viewport hier nicht gesetzt werden,
			// sondern erst beim sichtbarschalten (Hintergrund: OL setzet den Viewport nicht, da Size der Karte [-2 -2]
			// es kommt dann zur Endlosrekursion und unzähligen WMS-Requests mit BOX=NAN,NAN,NAN,NAN)
			// Workaround: Viepwort hier merken und beim toggleVisibility setzen
			self._overview_viewport = view.overview.viewport;
			if (self.isVisible())
			{
				self._overview_map.setViewport(view.overview.viewport);
			}
		}
	}
	else
	{
		gc.gis.iface.log.debug(self, 'GCOverview: No overview config found in "' + view.name + '".');
	}

	self._overview_map.updateMap();
};

/**
 *
 */
gc.gis.module.GCOverview.prototype.updateViewport = function()
{
	if (this.isVisible()) {
		this._impl._updateViewport();
	}
};

/**
 *
 */
gc.gis.module.GCOverview.prototype.setCurrentExtent = function()
{
	this._overview_viewport = {
		geometry: this._reference_map.getViewport().geometry,
		projection: this._reference_map.getProjection()
	};

	if (this.isVisible()) {
		this._overview_map.setViewport(this._overview_viewport);
	}
};


/**
 *
 */
gc.gis.module.GCOverview.prototype.setCurrentLayers = function()
{
	var layers = this._reference_map.getLayers();

	this._overview_map.removeAllLayers();

	for( var i=0; i<layers.length; i++ )
	{
		try
		{
			this._overview_map.loadLayer( layers[i].toObject() )
		}
		catch( err )
		{
			gc.gis.iface.log.error( this, err );
		}
	}

	this._overview_map.updateMap();
};


/**
 * Setzt die Eigenschaften der Übersichtskarte auf die zuletzt geladenen Ansicht.
 */
gc.gis.module.GCOverview.prototype.applyLastView = function()
{
	var view = gc.gis.iface.getLastView();
	if (view)
	{
		this.applyView(view);
	}
};


/**
 * @classdesc
 * Zeigt/Versteckt die Übersichtskarte.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.module.GCOverview
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCOverview} options.module Modulinstanz
 *   Layer
 */
gc.gis.module.GCOverview.ToggleVisibility = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doToggle;
	/**
	 * @inheritdoc
	 */
	this.args = [options.module];
};
gc.gis.module.GCOverview.ToggleVisibility.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

gc.gis.module.GCOverview.ToggleVisibility.prototype.doToggle = function( module )
{
	module.toggleVisibility();
};

